import {
  IconBrandSpotifyFilled,
  IconBrandInstagram,
  IconBrandTiktokFilled,
  IconBrandYoutubeFilled,
  IconMailFilled,
} from "@tabler/icons-react";

export enum Platform {
  INSTAGRAM,
  SPOTIFY,
  TIKTOK,
  YOUTUBE,
  EMAIL,
}

const EMAIL = "robertomasanti@gmail.com";

const Social = ({ platform, size }: { platform: Platform; size: number }) => {
  const getURL = () => {
    let result = "";

    switch (platform) {
      case Platform.INSTAGRAM:
        result = "https://www.instagram.com/robertomasanti";
        break;
      case Platform.SPOTIFY:
        result = "";
        break;
      case Platform.TIKTOK:
        result = "";
        break;
      case Platform.YOUTUBE:
        result = "";
        break;
      case Platform.EMAIL:
        result = `mailto:${EMAIL}`;
        break;

      default:
        break;
    }

    return result;
  };

  const getIcon = (platform: Platform) => {
    let result = null;

    switch (platform) {
      case Platform.INSTAGRAM:
        result = <IconBrandInstagram size={size} />;
        break;
      case Platform.SPOTIFY:
        result = <IconBrandSpotifyFilled size={size} />;
        break;
      case Platform.TIKTOK:
        result = <IconBrandTiktokFilled size={size} />;
        break;
      case Platform.YOUTUBE:
        result = <IconBrandYoutubeFilled size={size} />;
        break;
      case Platform.EMAIL:
        result = (
          <div className="flex flex-row gap-2 justify-center items-center mobile:flex-col mobile:gap-1 mobile:flex-col-reverse">
            <span className="text-sm">{EMAIL}</span>
            <IconMailFilled size={size} />
          </div>
        );
        break;

      default:
        break;
    }

    return result;
  };

  return (
    <a
      className="text-white hover:text-[#BBA981] active:scale-95"
      href={getURL()}
      target="blank_"
    >
      {getIcon(platform)}
    </a>
  );
};

export default Social;
